import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, FileSpreadsheet, Users, Route, BarChart3, Truck, LogOut, Menu, X, FileText, CalendarClock, KeyRound, Map, History, ShieldCheck } from 'lucide-react';

const navItems = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard', perm: null },
  { to: '/invoices', icon: FileSpreadsheet, label: 'Invoices', perm: 'invoices' },
  { to: '/drivers', icon: Users, label: 'Drivers', perm: 'drivers' },
  { to: '/route-planner', icon: Route, label: 'Route Planner', perm: 'route_planner' },
  { to: '/live-map', icon: Map, label: 'Live Map', perm: 'live_map' },
  { to: '/analytics', icon: BarChart3, label: 'Analytics', perm: 'analytics' },
  { to: '/driver-reports', icon: FileText, label: 'Driver Reports', perm: 'driver_reports' },
  { to: '/rescheduled', icon: CalendarClock, label: 'Rescheduled', perm: 'rescheduled' },
  { to: '/users', icon: ShieldCheck, label: 'User Management', perm: 'users', adminOnly: true },
];

// Filter nav items by the logged-in user's permissions
function canView(item, user) {
  if (item.adminOnly) return user.role === 'admin';
  if (!item.perm) return true; // Dashboard always visible
  if (user.role === 'admin' || user.permissions === 'ALL') return true;
  const perms = user.permissions || {};
  return perms[item.perm] && perms[item.perm].view === true;
}

export default function Layout() {
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const logout = () => { localStorage.clear(); navigate('/login'); };

  return (
    <div style={{ display:'flex', height:'100vh', background:'#f8fafc', fontFamily:'Inter, sans-serif' }}>
      <div style={{ width: open ? 220 : 60, background:'#1e293b', transition:'width 0.2s', display:'flex', flexDirection:'column', flexShrink:0 }}>
        <div style={{ padding:'16px', display:'flex', alignItems:'center', gap:10, borderBottom:'1px solid #334155' }}>
          <Truck size={22} color="#38bdf8" />
          {open && <span style={{ color:'#f1f5f9', fontWeight:700, fontSize:14, lineHeight:1.2 }}>Mihan<br/>Logistics</span>}
          <button onClick={() => setOpen(!open)} style={{ marginLeft:'auto', background:'none', border:'none', color:'#94a3b8', cursor:'pointer' }}>
            {open ? <X size={16} /> : <Menu size={16} />}
          </button>
        </div>
        <nav style={{ flex:1, padding:'8px', overflowY:'auto' }}>
          {navItems.filter(item => canView(item, user)).map(({ to, icon: Icon, label }) => (
            <NavLink key={to} to={to} end={to === '/'}
              style={({ isActive }) => ({
                display:'flex', alignItems:'center', gap:10, padding:'9px 10px',
                borderRadius:8, marginBottom:2, textDecoration:'none',
                background: isActive ? '#0f172a' : 'transparent',
                color: isActive ? '#38bdf8' : '#94a3b8', fontSize:13, fontWeight:500
              })}>
              <Icon size={18} />{open && label}
            </NavLink>
          ))}
        </nav>
        <div style={{ padding:'12px', borderTop:'1px solid #334155' }}>
          {open && <div style={{ color:'#64748b', fontSize:11, marginBottom:8 }}>{user.name || 'Admin'}</div>}
          <button onClick={logout} style={{ display:'flex', alignItems:'center', gap:8, color:'#94a3b8', background:'none', border:'none', cursor:'pointer', fontSize:13, padding:'6px 4px' }}>
            <LogOut size={16} />{open && 'Logout'}
          </button>
        </div>
      </div>
      <div style={{ flex:1, overflow:'auto', display:'flex', flexDirection:'column' }}>
        <Outlet />
      </div>
    </div>
  );
}
